<template>
  <div id="preLoader" class="loader">
    <span :class="`${type}`"></span>
    <span :class="`${type}`"></span>
    <span :class="`${type}`"></span>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  name: 'ButtonLoader',
  props: {
    type: {
      type: String,
      default: 'default',
    },
  },
});
</script>
<style scoped lang="scss" src="./ButtonLoader.scss" />
